import { format, parseISO } from 'date-fns';

import type { PayrollReceipt } from '../types';

/**
 * Builds download filename: Recibo_Nomina_Periodo_{periodNumber}_{Month}_{Year}.pdf
 */
function getDownloadFilename(receipt: PayrollReceipt): string {
  const endDate = parseISO(receipt.endDate);
  const month = format(endDate, 'MMM'); // e.g. Mar, Apr
  const year = format(endDate, 'yyyy');
  const safeMonth = month.replace(/\s/g, '_');
  return `Recibo_Nomina_Periodo_${receipt.periodNumber}_${safeMonth}_${year}.pdf`;
}

/**
 * Downloads the receipt PDF by creating a temporary anchor element.
 * Works for both same-origin and cross-origin URLs.
 */
export function downloadReceiptPdf(receipt: PayrollReceipt): void {
  const a = document.createElement('a');
  a.href = receipt.pdfUrl;
  a.download = getDownloadFilename(receipt);
  a.target = '_blank'; // Fallback: opens in new tab if download fails
  a.rel = 'noopener noreferrer';

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
